module.exports = __webpack_public_path__ + "img/hourglass-yellow.bbce69e8.svg";